import type { HyperEntityConfig } from "@shared/backend/hyper-entity.decorator";
import {
  emptyToNull,
  isVolunteerOrgBranch,
} from "@shared/helpers/volunteer-organization";
import { Roles } from "@shared/Roles";
import { remult } from "remult";
import { VolunteerOrganization } from "../volunteer-organization/entity";
import type { VolunteerOrgProjectAssignment } from "./entity";

export const VolunteerOrgProjectAssignmentEntityConfig: HyperEntityConfig<VolunteerOrgProjectAssignment> =
  {
    allowApiRead: true,
    allowApiCrud: Roles.AdminsAndManager,
    apiPrefilterPerRole: (filter) => {
      if (!remult.user) return;
      filter(Roles.AdminsAndManager, true);
      filter(Roles.User, false);
    },
    allowInsertPerRole(allow) {
      allow(Roles.AdminsAndManager, true);
    },
    allowDeleteAndUpdatePerRole(allow) {
      allow(Roles.AdminsAndManager, true);
    },
    async saving(entity) {
      if (!entity.volunteerOrganizationId?.trim()) {
        throw new Error("שלוחה חובה");
      }
      if (!entity.projectId?.trim()) {
        throw new Error("פרויקט חובה");
      }
      entity.address = emptyToNull(entity.address) ?? "";
      if (!entity.address) {
        throw new Error("מיקום השיבוץ חובה");
      }
      entity.notes = emptyToNull(entity.notes);
      if (
        entity.volunteerCount == null ||
        !Number.isFinite(entity.volunteerCount) ||
        entity.volunteerCount < 0
      ) {
        throw new Error("מספר המתנדבים חייב להיות אפס או יותר");
      }
      entity.volunteerCount = Math.floor(entity.volunteerCount);

      const org = await remult
        .repo(VolunteerOrganization)
        .findId(entity.volunteerOrganizationId);
      if (!org) {
        throw new Error("ארגון מתנדבים לא נמצא");
      }
      if (!isVolunteerOrgBranch(org)) {
        const childCount = await remult.repo(VolunteerOrganization).count({
          parentId: org.id,
        });
        if (childCount > 0) {
          throw new Error("ארגון אב לא מקבל שיבוץ. השיבוץ נעשה בשלוחה.");
        }
      }
    },
  };
